import { CheckList } from '@work4all/models/lib/Classes/CheckList.entity';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { EntityPicker, IEntityPicker } from '../EntityPicker';

export type ICheckListPickerProps<TMultiple extends boolean> = Omit<
  IEntityPicker<CheckList, TMultiple>,
  'entity'
>;

export function CheckListPicker<TMultiple extends boolean>(
  props: ICheckListPickerProps<TMultiple>
) {
  return <EntityPicker entity={Entities.checkList} {...props} />;
}
